/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
import typeDefs from './schema.js'
import { link } from './plugins/links'

// Disable apollo injection if testing
if (process.env.NODE_ENV !== 'test') {
  // Install the vue plugin
  Vue.use(VueApollo)
}

// Http endpoint
const httpEndpoint = process.env.VUE_APP_API_PATH || 'http://localhost:4000'

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000',
  // wsEndpoint: 'http://localhost:4000/subscriptions',
  wsEndpoint: null,
  // LocalStorage token
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  typeDefs,
  resolvers: {}
}

// Create apollo client
const { apolloClient } = createApolloClient({
  ...defaultOptions,
  link
})

export const client = apolloClient

// Create vue apollo provider
export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      fetchPolicy: 'no-cache'
    }
  },
  errorHandler (error) {
    // eslint-disable-next-line no-console
    console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
  }
})
